import React from "react";
import {PaymentDetails} from "./PaymentDetailsContainer";
import AutoPayBox from "./autoPayBox";
import BankAccountInfo from "./bankAccountInfo";
import MicroDepositsBankAccount from "./microDepositsBankAccount";
import {CustomGrid} from "../custom-common";

const PaymentMethodSelected = ({YourCost, removeBankAccount, strings, plaidEnviroment, plaidLinkToken, setPlaidData,
        removeMicroDepositsBankAccount}) => {

    const {bankAccountPmData, microDepositsBankAccountPmData} = PaymentDetails.useContainer()
    const showMicroDepositsBankAccount = microDepositsBankAccountPmData && !bankAccountPmData

    return (
        <CustomGrid.Row columns={2}>
            <CustomGrid.Column>
                { !!bankAccountPmData &&
                    <BankAccountInfo
                        YourCost={YourCost}
                        removeBankAccount={removeBankAccount}
                        data={bankAccountPmData}
                        strings={strings}
                    />
                }
                { !!showMicroDepositsBankAccount &&
                    <MicroDepositsBankAccount
                        YourCost={YourCost}
                        removeBankAccount={removeMicroDepositsBankAccount}
                        data={microDepositsBankAccountPmData}
                        strings={strings}
                        plaidEnviroment={plaidEnviroment}
                        plaidLinkToken={plaidLinkToken}
                        setPlaidData={setPlaidData}
                    />
                }
            </CustomGrid.Column>
            <CustomGrid.Column>
                <AutoPayBox strings={strings} />
            </CustomGrid.Column>
        </CustomGrid.Row>
    )
}

export default PaymentMethodSelected;
